module.exports = __webpack_public_path__ + "img/bubble5.aefcdc02.svg";